// extracted by css-extract-rspack-plugin
export default {"cls1":"AiSummary-cls1_SR1","cls2":"AiSummary-cls2_IEf AiSummary-cls1_SR1"};